export default [
    {
        label: 'Select an source',
        value: '',
    },
    {
        label: 'Microsoft Ads',
        value: 'Microsoft_Ads'
    },
    {
        label: 'Facebook Ads',
        value: 'Facebook_Ads'
    },
    {
        label: 'Other',
        value: 'other'
    }
];